import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SafeModule } from 'src/app/@core/pipes/pipe-modules/safe.module';
import { MatrialFeaturesRowComponent } from './features-row.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    MatrialFeaturesRowComponent
  ],
  imports: [
    CommonModule,
    SafeModule.forRoot(),
    FlexLayoutModule,
    MatButtonModule,
    FormsModule
  ],
  exports: [MatrialFeaturesRowComponent]
})

export class MaterialFeaturesRowModule {}